import React from "react";
import { Link } from "react-router-dom";
import {
  FiChevronLeft,
  FiPlus,
  FiTrash2,
  FiEdit2,
} from "react-icons/fi";


const LeftBar = ({
  classes,
  setClasses,
  setShowClassModal,
  setModalMode,
  setNewClassName,
  polygons,
  setPolygons,
  projectName,
  userName,
  selectedPolygonForModal,
  setSelectedPolygonForModal,
  setShowRectModal,
  setRectModalPosition,
  stageRef,
}) => {

  // console.log("LeftBar polygons:", polygons);
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this rectangle?")) {
      const updatedRectangles = polygons.filter(rect => rect.id !== id);
      setPolygons(updatedRectangles);
      if (selectedPolygonForModal?.id === id) {
        setSelectedPolygonForModal(null);
        setShowRectModal(false);
      }
    }
  };

  const handleRectClick = (rect) => {
    if (selectedPolygonForModal?.id === rect.id) {
      // If already selected, deselect
      setSelectedPolygonForModal(null);
      setShowRectModal(false);
    } else {
      // Select the rectangle
      setSelectedPolygonForModal(rect);
      
      // Calculate modal position (center of rectangle)
      const stage = stageRef.current;
      if (stage) {
        const rectCenter = {
          x: rect.x + rect.width / 2,
          y: rect.y + rect.height / 2
        };
        
        const stageRect = stage.container().getBoundingClientRect();
        setRectModalPosition({
          x: stageRect.left + rectCenter.x,
          y: stageRect.top + rectCenter.y
        });
        setShowRectModal(true);
      }
    }
  };

  const getClassCounts = () => {
    const counts = {};
    polygons.forEach(rect => {
      // For OCR, count by class property (string)
      if (rect.class) {
        counts[rect.class] = (counts[rect.class] || 0) + 1;
      }
    });
    return counts;
  };

  const classCounts = getClassCounts();

  return (
    <div className="w-48 bg-gray-100 p-4 border-r flex flex-col h-full">
      <Link
        to={`/project/${userName}/${projectName}`}
        className="mb-4 bg-white px-2 py-1 rounded hover:bg-blue-100 hover:text-blue-500 hover:underline flex items-center"
      >
        <FiChevronLeft /> Project Overview
      </Link>
      
      <div className="flex justify-between items-center mb-2">
        <h3 className="text-lg font-semibold text-gray-800">Rectangles</h3>
        <span className="text-xs bg-gray-200 px-2 py-1 rounded">
          {polygons.length} total
        </span>
      </div>
      
      <div className="flex-1 overflow-y-auto min-h-0">
        <ul className="space-y-1 text-xs text-gray-700">
          {polygons.map((rect) => (
            <li
              key={rect.id}
              className={`flex items-center justify-between px-2 py-0.5 rounded group cursor-pointer ${
                selectedPolygonForModal?.id === rect.id 
                  ? 'bg-blue-100 border border-blue-300' 
                  : 'hover:bg-gray-200'
              }`}
              onClick={() => handleRectClick(rect)}
            >
              <div className="flex items-center">
                <div 
                  className="w-2 h-2 rounded-full mr-2"
                  style={{ 
                    backgroundColor: '#03a1fc',
                    opacity: 0.3
                  }}
                />
                <span className="truncate">
                  {rect.class || 'Unlabeled'}
                  {selectedPolygonForModal?.id === rect.id && (
                    <span className="ml-2 text-xs text-gray-500">
                      ({classCounts[rect.class || 'Unlabeled'] || 0})
                    </span>
                  )}
                </span>
              </div>
              <div className="flex space-x-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDelete(rect.id);
                  }}
                  className="text-red-500 hover:text-red-700"
                  title="Delete"
                >
                  <FiTrash2 size={12} />
                </button>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <button
        onClick={() => {
          setModalMode("add");
          setNewClassName("");
          setShowClassModal(true);
        }}
        className="mt-4 flex items-center justify-center w-full px-3 py-2 text-sm bg-blue-500 text-white rounded hover:bg-blue-600"
      >
        <FiPlus className="mr-1" />
        Add Class
      </button>
    </div>
  );
};

export default LeftBar;